export const UPDATENOTE = 'update_note'
export const UPDATEMYINFO = 'update_myinfo'